import { createTelemetry, createTelemetryObject } from '@shared/core/analytics';

const smartAppBannerTelemetry = createTelemetryObject({
  actions: {
    // APP Section
    weHaveAnAppClicked: (app: string, category: string) => ({
      action: 'WeHaveAnAppClicked',
      actionType: 'click',
      category,
      label: app,
    }),
    stayOnWebClicked: (category: string) => ({
      action: 'StayOnWebClicked',
      actionType: 'click',
      category,
    }),
  },
});

// Only the hook is taken. `createTelemetry` also returns a `TelemetryProvider`, but this telemetry
// object is created with no `context`, so the provider would supply the same `actions` and the same
// `context: undefined` the default already carries — the sole difference being an `updateContext`
// that `useTelemetry` never calls unless passed `contextUpdate`/`addToContext`. Not exporting it
// keeps anyone from mounting a provider that provably does nothing.
const { useTelemetry: useSmartAppBannerTelemetry } = createTelemetry(smartAppBannerTelemetry);
export { useSmartAppBannerTelemetry };
